import numeral from "numeral";

function formatPrice(price: number) {
  return numeral(price).format("0,0");
}

function formatBalanceUser(price: number) {
  return numeral(price).format("0,0");
}

export { formatPrice, formatBalanceUser };
